module.exports = __webpack_public_path__ + "static/helvetica-neue-175966adf4329b52f730efa26f76deae.woff2";